// Bespoke voxel prefabs (shared voxel helpers and palette). Split out of creatures_extra.ts, whose
// CREATURE_PREFABS_EXTRA registry still assembles them.

import type { BlockVoxel } from './types.js';

/** Optional per-voxel material overrides passed to `box()`. */
export interface VoxelMaterialOpts {
  readonly roughness?: number;
  readonly metalness?: number;
  readonly emissive?: string;
  readonly team?: boolean;
}

export function box(
  sx: number,
  sy: number,
  sz: number,
  w: number,
  h: number,
  d: number,
  color: string,
  opts?: VoxelMaterialOpts,
): BlockVoxel[] {
  const out: BlockVoxel[] = [];
  for (let x = sx; x < sx + w; x++) {
    for (let y = sy; y < sy + h; y++) {
      for (let z = sz; z < sz + d; z++) {
        out.push({ x, y, z, color, ...opts });
      }
    }
  }
  return out;
}

export const SKIN = '#f1c27d';
export const HAIR_DARK = '#3b2f1c';

// Team greys: the renderer maps these onto the owner's colour (see
// BlockVoxel.team), light for the tabard face, darker for trim and folds.
export const TEAM_LIGHT = '#d8d8d8';
export const TEAM_DARK = '#9c9c9c';
export const STEEL = { roughness: 0.35, metalness: 0.85 } as const;
